////////////////
// markup and click handler


//<a data-testtype="st" href="/Sethtest/index.html">SehTest</a>

// $('a[data-testtype]').on('click', $.initTestDataProcess);

// TODO: Link auf API-Test mit ID als GET-Parameter im Testsystem

////////////////

(function ($) {

  'use strict';

  $.fn.initTestDataProcess = function (event) {
    event.preventDefault();

  	var testDataRequest = {
  		idRequest: true,
  		width: window.innerWidth,
  		height: window.innerHeight,
  		url: location.href
  	};
  	$.ajax({
  		type: 'post',
  		url: '/api/v1/' + $(this).attr('data-testtype'),
  		data: JSON.stringify(testDataRequest),
  		dataType: 'json',
  		success: function(result) {
  			if (result.status && typeof result.id === 'string') {
          // use the href from the a element and append the requestes id
  				location.href = $(this).attr('href') + (testUrl.match(/\?/) ? '&' : '?') + 'id=' + result.id;
  			}
  		},
  		error: function() {
  			console.error('Error initializíng Test', arguments);
  			// messi message to inform the user about the problem
  			// using a text constant: $.i81n.text(testType + '-error') //
  		}
  	});
  };

}(jQuery));
